// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NewsletterBackButton_wrapper__3EGfc"};